import toast from 'react-hot-toast';
import { call, put, takeLatest, select } from 'redux-saga/effects';
import * as types from '../../../../../constants/ActionNameConstants';
import { SAVE_FILE_MERGE_STATUS_CGA_API_URL } from '../../../../../constants/ApiUrlConstants';
import { postApiRequest } from '../../../../../features/axiosClient';
import { cgaFilesRequest, saveFileMergeStatusCGAFailure, saveFileMergeStatusCGASuccess } from '../actions';

function* handleSaveFileMergeStatusCGAAPI(action) {
    const { AudioFileId, TotalPages, File } = action.payload;
    const { currentPage, rowsPerPage, sortField, sortOrder, cgaSearchValue, isFilterApplied, filterFilesStatusData, filterClientData } = yield select((state) => state.cgaFileStates);

    try {
        const formData = new FormData();
        formData.append('File', File);

        const url = `${SAVE_FILE_MERGE_STATUS_CGA_API_URL}?AudioFileId=${AudioFileId}&TotalPages=${TotalPages}`;

        const response = yield call(
            postApiRequest,
            url,
            formData,
        );
        if (response?.data?.errorMessage !== '' && !response.data?.success) {
            toast.error(response?.data?.errorMessage);
            return;
        }
        yield put(saveFileMergeStatusCGASuccess(response.data));
        yield put(cgaFilesRequest({
            page: currentPage + 1,
            rowNumber: rowsPerPage,
            sortRowName: sortField,
            sortRowDirection: sortOrder === 1 ? 'asc' : 'desc',
            search: cgaSearchValue,
            filter: isFilterApplied ?
                {
                    status: filterFilesStatusData?.length > 0 ? filterFilesStatusData : undefined,
                    clientId: filterClientData ? filterClientData : undefined,
                } : null
        }))
        toast.success('File merge status saved successfully');
    } catch (error) {
        yield put(saveFileMergeStatusCGAFailure(error));
        toast.error('Failed to save file merge status');
    }
}

export function* watchSaveFileMergeStatusCGA() {
    yield takeLatest(types.SAVE_FILE_MERGE_STATUS_CGA_REQUEST, handleSaveFileMergeStatusCGAAPI);
}